// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Ubuntu-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Ubuntu-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/Ubuntu-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/Ubuntu-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts/Ubuntu-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("fonts/Ubuntu-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("fonts/UbuntuMono-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("fonts/UbuntuMono-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("fonts/UbuntuMono-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("fonts/UbuntuMono-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}
@font-face {
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
}
@font-face {
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
}
@font-face {
  font-family: 'Ubuntu Mono';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
}
@font-face {
  font-family: 'Ubuntu Mono';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
}

html { 
  width: 100%;
  height: 100%;
  font-size: 1rem;
}
body { 
  width: 100%; 
  height:100%;
  background-color: #f9fafc !important;
}
#app { 
  width: 100%; 
  height: 100%;
  background-color: inherit;
}
h1, h2, h3, h4, h5, h6 {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/overrides/css-resetter.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;8DACiD;AACnD;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;8DACmD;AACrD;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;8DACkD;AACpD;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;8DACuD;AACzD;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;8DACoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX","sourcesContent":["@font-face {\n  font-family: 'Ubuntu';\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url(fonts/Ubuntu-Light.woff2) format('woff2'),\n        url(fonts/Ubuntu-Light.woff) format('woff');\n}\n@font-face {\n  font-family: 'Ubuntu';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(fonts/Ubuntu-Regular.woff2) format('woff2'),\n        url(fonts/Ubuntu-Regular.woff) format('woff');\n}\n@font-face {\n  font-family: 'Ubuntu';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(fonts/Ubuntu-Medium.woff2) format('woff2'),\n        url(fonts/Ubuntu-Medium.woff) format('woff');\n}\n@font-face {\n  font-family: 'Ubuntu Mono';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(fonts/UbuntuMono-Regular.woff2) format('woff2'),\n        url(fonts/UbuntuMono-Regular.woff) format('woff');\n}\n@font-face {\n  font-family: 'Ubuntu Mono';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(fonts/UbuntuMono-Bold.woff2) format('woff2'),\n        url(fonts/UbuntuMono-Bold.woff) format('woff');\n}\n\nhtml { \n  width: 100%;\n  height: 100%;\n  font-size: 1rem;\n}\nbody { \n  width: 100%; \n  height:100%;\n  background-color: #f9fafc !important;\n}\n#app { \n  width: 100%; \n  height: 100%;\n  background-color: inherit;\n}\nh1, h2, h3, h4, h5, h6 {\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
